import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { PdfViewerModal } from '~/components/PdfViewerModal/pdfViewerModal';
import { useOverlayContext, useStoreActions, useStore } from '~/contexts';
import { selectors } from '~/store/state-selectors';
export function usePreviewCustomPagePdf(param) {
    let { biName, testId } = param;
    const businessId = useStore(selectors.user.businessId);
    const { api } = useStoreActions();
    const { showModal } = useOverlayContext();
    const openPreview = useCallback((pdfName, pdfFileName)=>{
        showModal({
            biName,
            closeOnEscapeKey: true,
            closeOnClickOutside: true,
            content: (param)=>{
                let { dismissModal: dismissPreview } = param;
                return /*#__PURE__*/ _jsx(PdfViewerModal, {
                    title: pdfFileName,
                    pdfUniqueName: pdfName,
                    getFileUrl: async (pdfUniqueName)=>{
                        const result = await api.customPage.getDownloadUrl(businessId !== null && businessId !== void 0 ? businessId : '', pdfUniqueName);
                        return result.url;
                    },
                    onClose: dismissPreview,
                    testId: testId
                });
            }
        });
    }, [
        api.customPage,
        biName,
        businessId,
        showModal,
        testId
    ]);
    return {
        openPreview
    };
}
